import * as Yup from 'yup';

import { EleicaoResponseType } from '../../types';

const validationSchemRemocaoEleicaoModal = (eleicao: EleicaoResponseType) =>
  Yup.object().shape({
    titulo_eleicao: Yup.string().test((value: any) => {
      return value === eleicao?.titulo;
    }),
  });

export default validationSchemRemocaoEleicaoModal;
